// When the splash shows: once per visit (a browser session), never on a route change, and the visitor can ask for less motion.
const KEY = 'rb_splash_seen';
export const SPLASH_MS = 5000;               // the splash stays 5 seconds (the page loads underneath); a tap on it skips it
export const SPLASH_FADE_MS = 400;

export function shouldShowSplash(storage = (typeof window !== 'undefined' ? window.sessionStorage : null)) {
  try {
    if (!storage) return true;
    if (storage.getItem(KEY)) return false;
    storage.setItem(KEY, '1');
    return true;
  } catch (e) { return true; }                 // storage blocked: show it (the max time still ends it)
}

export function prefersReducedMotion(win = (typeof window !== 'undefined' ? window : null)) {
  try { return !!(win && win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; }
}
